import { jobProfileConstants } from "../constants";

export const jobProfiles = (state = { jobLoader: false }, action) => {
  switch (action.type) {
    case jobProfileConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case jobProfileConstants.GETALL_SUCCESS:
      return {
        ...state,
        jobProfile: action.jobProfile,
      };
    case jobProfileConstants.GETALL_SUCCESS_LOADER:
      return {
        ...state,
        jobLoader: action.jobLoader,
      };
    case jobProfileConstants.GETALL_FAILURE:
      return {
        error: action.error,
      };
    case jobProfileConstants.CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case jobProfileConstants.CREATE_SUCCESS:
      return {
        ...state,
      };
    case jobProfileConstants.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case jobProfileConstants.GET_REFERRAL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case jobProfileConstants.GET_REFERRAL_SUCCESS:
      return {
        ...state,
        referralData: action.referralData,
      };
    case jobProfileConstants.GET_REFERRAL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case jobProfileConstants.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case jobProfileConstants.UPDATE_SUCCESS:
      return {
        ...state,
      };
    case jobProfileConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case jobProfileConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case jobProfileConstants.DELETE_SUCCESS:
      return {
        ...state,
      };
    case jobProfileConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };
    case jobProfileConstants.GET_REQUEST:
      return {
        ...state,
      };
    case jobProfileConstants.GET_SUCCESS:
      return {
        ...state,
        assignee: action.assignee,
      };
    case jobProfileConstants.GET_FAILURE:
      return {
        error: action.error,
      };
    case jobProfileConstants.GETJOB_REQUEST:
      return {
        ...state,
      };
    case jobProfileConstants.GETJOB_SUCCESS:
      return {
        ...state,
        masterData: action.masterData,
      };
    case jobProfileConstants.GETJOB_FAILURE:
      return {
        error: action.error,
      };
    case jobProfileConstants.GETJOBLIST_REQUEST:
      return {
        ...state,
      };
    case jobProfileConstants.GETJOBLIST_SUCCESS:
      return {
        ...state,
        jobData: action.jobData,
      };
    case jobProfileConstants.GETJOBLIST_FAILURE:
      return {
        error: action.error,
      };

    case jobProfileConstants.GETCLUSTERLIST_REQUEST:
      return {
        ...state,
      };
    case jobProfileConstants.GETCLUSTERLIST_SUCCESS:
      return {
        ...state,
        cluster: action.cluster,
      };
    case jobProfileConstants.GETCLUSTERLIST_FAILURE:
      return {
        error: action.error,
      };
    case jobProfileConstants.GETINTERVIEW_REQUEST:
      return {
        ...state,
      };
    case jobProfileConstants.GETINTERVIEW_SUCCESS:
      return {
        ...state,
        inetviewer: action.inetviewer,
      };
    case jobProfileConstants.GETINTERVIEW_FAILURE:
      return {
        error: action.error,
      };
    case jobProfileConstants.GETSEARCHUSER_REQUEST:
      return {
        ...state,
      };
    case jobProfileConstants.GETSEARCHUSER_SUCCESS:
      return {
        ...state,
        searchUser: action.searchUser,
      };
    case jobProfileConstants.GETSEARCHUSER_FAILURE:
      return {
        error: action.error,
      };
    case jobProfileConstants.GETCITIES_REQUEST:
      return {
        ...state,
      };
    case jobProfileConstants.GETCITIES_SUCCESS:
      return {
        ...state,
        citiesData: action.data,
      };
    case jobProfileConstants.GETCITIES_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
};
